module.exports = __webpack_public_path__ + "img/1M.172363e4.jpg";